// SPDX-FileCopyrightText: Copyright 2024 Dash0 Inc.

"use client";

import { ReactNode } from "react";

import { IntegrationDetailPageHeader } from "@/hub/pages/integration-detail-page/components/integration-detail-page-header";
import { IntegrationTabContent } from "@/hub/pages/integration-detail-page/components/overview-tab";

import {
  DashboardTemplateMetadata,
  ExtendedIntegrationMetadata,
  Index,
  ViewMetadata,
} from "@/hub/types";
import { CompiledCheckRule } from "@/hub/pages/integration-detail-page/types";

import SideBar from "@/hub/components/SideBar";
import { HubResourceProvider } from "@/hub/components/mdx/hub-resource-context";
import { Heading } from "@/hub/pages/integration-detail-page/integration-detail-page";

type IntegrationDetailPageImplProps = {
  index: Index;
  integration: ExtendedIntegrationMetadata;
  dashboardTemplates: DashboardTemplateMetadata[];
  checkRules: CompiledCheckRule[];
  views: ViewMetadata[];
  relatedIntegrations: ExtendedIntegrationMetadata[];
  docs: {
    content: ReactNode;
    id: string;
    label: string;
    mainHeading?: string;
  }[];
  headings: Heading[];
};

export function IntegrationDetailPageImpl({
  index,
  integration,
  dashboardTemplates,
  checkRules,
  views,
  relatedIntegrations,
  docs,
  headings,
}: IntegrationDetailPageImplProps) {

  return (
    <div className="flex gap-16 h-full md:py-8 py-4">
      <div className="flex flex-col">
        <IntegrationDetailPageHeader integration={integration} />
        <HubResourceProvider
          resourceKind={integration.kind}
          resourceId={integration.id}
          index={index}
        >
          <IntegrationTabContent
            index={index}
            integration={integration}
            dashboardTemplates={dashboardTemplates}
            checkRules={checkRules}
            views={views}
            relatedIntegrations={relatedIntegrations}
            docs={docs}
          />
        </HubResourceProvider>
      </div>
      <SideBar headings={headings} title="In this section" />
    </div>
  );
}
